import React from "react";
import SearchCategories from "./SearchCategories";
import SearchFilterBtn from "./SearchFilterBtn";
import SearchFoodItems from "./SearchFoodItems";
import SearchHeader from "./SearchHeader";

const SearchPage = () => {
  return (
    <div>
      <SearchHeader />
      <SearchFilterBtn />
      <SearchCategories />
      <SearchFoodItems />
    </div>
  );
};

export default SearchPage;
